import { render, staticRenderFns } from "./ImportHistoryDetailTable.vue?vue&type=template&id=5892cdd0"
import script from "./ImportHistoryDetailTable.vue?vue&type=script&lang=js"
export * from "./ImportHistoryDetailTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports